export const ChatTranslations = {
  en: {
    memberRemovedSuccess: "Member removed successfully.",
    leftGroupSuccess: "You have left the group successfully.",
    confirmRemoval: "Confirm Removal",
    confirmRemovalMessage: "Are you sure you want to remove this member?",
    cancel: "Cancel",
    confirm: "Confirm",
    chatsTab: "Chats",
    groupsTab: "Groups",
    invitesTab: "Invites",
    createNewGroup: "Create New Group",
    makeDeal: "Make a deal",
    allRequests: "All request",
    myInvites: "My invites",
    noContactsFound: "No contacts found",
    verificationPending: "Verification Pending",
    noGroupsFound: "No groups found",
    createFirstGroup: "Create your first group",
    noInvitesFound: "No invites found",
    invitesWillAppearHere: "Invites will appear here",
    noChatsFound: "No chats found",
    startNewChat: "Start new chat",
    noGroupFound: "No group found",
    createNewGroupHint: "Create new group",
    noChatMessagesYet: "No chat messages yet",
    noGroupMessagesYet: "No group messages yet",
    decline: "Decline",
    accept: "Accept",
    userWantsToContactYou: "User wants to contact you",
    acceptInvite: "Accept Invite",
    dismissInvite: "Dismiss Invite",
    messagePlaceholder: "Type a message...",
    filesToSend: "Files to send",
    clearAll: "Clear all",
    uploading: "Uploading...",
    dealDetails: "Deal Details",
    paymentDetails: "Payment Details",
    total: "Total",
    withdrawn: "Withdrawn",
    contractType: "Contract type",
    fightStyle: "Fight style",
    eventName: "Event name",
    eventLocation: "Event location",
    date: "Date",
    today: "Today",
    yesterday: "Yesterday",
    dealStatusMessageFailed: "The deal was updated, but the chat message could not be sent.",
    system: {
      dealAccepted: "{{name}} has accepted the deal: {{summary}} {{dealId}}",
      dealRejected: "{{name}} has declined the deal: {{summary}} {{dealId}}",
      dealWithdrawn: "{{name}} has withdrawn the deal: {{summary}} {{dealId}}",
      forSport: " for {{sport}}",
      previewAccepted: "Deal accepted: {{dealId}}",
      previewRejected: "Deal declined: {{dealId}}",
      previewWithdrawn: "Deal withdrawn: {{dealId}}",
    },
    dealTypes: {
      FIGHT_SINGLE: "Fight Single",
      FIGHT_TOURNAMENT: "Fight Tournament",
      SPARRING: "Sparring",
    },
    dealStatus: {
      PROPOSED: "Proposed",
      ACCEPTED: "Accepted",
      CONFIRMED: "Confirmed",
      WAITING_FOR_RESULT: "Waiting for result",
      RESULT_UPDATED: "Result updated",
      RESULT_CONFIRMED: "Result confirmed",
      FINISHED: "Finished",
      FIGHTER_RATED: "Fighter rated",
      MANAGER_RATED: "Manager rated",
      CANCELLED: "Withdrawn",
      DISPUTE: "Dispute",
      REJECTED: "Rejected",
      EXPIRED: "Expired",
      CLOSED: "Closed",
    },
    componentLabels: {
      BASE_AMOUNT: "Base Amount",
      TRAVEL_EXPENSE: "Travel Expense",
      PERFORMANCE_BONUS: "Performance Bonus",
      BONUS: "Bonus",
      ON_WEIGHT_BONUS: "On Weight Bonus",
    },
    typeLabel: "Type:",
    priceLabel: "Price:",
    sportLabel: "Sport:",
    locationLabel: "Location:",
    eventDateLabel: "Event Date:",
    acceptButton: "Accept",
    acceptBlockedByDocuments: "Required document pending",
    addAccountDetails: "Add Account Details",
   
    declineButton: "Decline",
    editButton: "Edit",
    withdrawButton: "Withdraw",
    startConversation: "Start your conversation with {name}",
    messagesWillAppearHere: "Messages will appear here",
    selectContactOrGroup: "Select a contact or group",
    chooseSomeoneToChat: "Choose someone to start chatting",
    chooseGroupToChat: "Choose Group to Chat",
    selectGroup: "Select Group",
    groupInfo: "Group Info",
    addMembers: "Add Members",
    leaveGroup: "Leave Group",
    noMembersFound: "No members found.",
    leaveGroupConfirm: "Are you sure you want to leave the group?",
    cancelButton: "Cancel",
    leaveButton: "Leave",
    leaving: "Leaving...",
    makeADeal: "Make a Deal",
    updating: "Updating...",
    loadingMessages: "Loading messages...",
    dealDetailsAria: "Deal Details",
    membersUpdatedSuccessfully: "Member Updated Successfully",
    areYouSureLeaveGroup: "Are you sure leaving Group",
    selectInvite: "Select invite",
    chooseInviteToView: "Choose invite to view",
    dropFiles: "Drop files here",
    fileLimits: "Images, videos, documents supported",
    fileLimitsWithoutVideo: "Images and documents supported",
  },
  de: {
    selectInvite: "Einladung auswählen",
    chooseInviteToView: "Wählen Sie eine Einladung zum Anzeigen",
    memberRemovedSuccess: "Mitglied erfolgreich entfernt.",
    leftGroupSuccess: "Du hast die Gruppe erfolgreich verlassen.",
    confirmRemoval: "Entfernung bestätigen",
    confirmRemovalMessage:
      "Sind Sie sicher, dass Sie dieses Mitglied entfernen möchten?",
    cancel: "Abbrechen",
    verificationPending: "Verifizierung ausstehend",
    confirm: "Bestätigen",
     addAccountDetails: "Kontodetails hinzufügen",
    chatsTab: "Chats",
    groupsTab: "Gruppen",
    invitesTab: "Einladungen",
    createNewGroup: "Neue Gruppe erstellen",
    allRequests: "Alle Anfragen",
    myInvites: "Meine Einladungen",
    makeDeal: "Einen Deal machen",
    noContactsFound: "Keine Kontakte gefunden",
    noGroupsFound: "Keine Gruppen gefunden",
    createFirstGroup: "Erstellen Sie Ihre erste Gruppe",
    noInvitesFound: "Keine Einladungen gefunden",
    invitesWillAppearHere: "Einladungen werden hier angezeigt",
    noChatsFound: "Keine Chats gefunden",
    startNewChat: "Neuen Chat starten",
    noGroupFound: "Keine Gruppe gefunden",
    createNewGroupHint: "Neue Gruppe erstellen",
    noChatMessagesYet: "Noch keine Chat-Nachrichten",
    noGroupMessagesYet: "Noch keine Gruppennachrichten",
    decline: "Ablehnen",
    accept: "Annehmen",
    userWantsToContactYou: "Benutzer möchte Sie kontaktieren",
    acceptInvite: "Einladung annehmen",
    dismissInvite: "Einladung ablehnen",
    messagePlaceholder: "Geben Sie eine Nachricht...",
    filesToSend: "Zu sendende Dateien",
    clearAll: "Alle löschen",
    uploading: "Hochladen...",
    dealDetails: "Angebotsdetails",
    paymentDetails: "Zahlungsdetails",
    total: "Gesamt",
    withdrawn: "Zur\u00fcckgezogen",
    contractType: "Vertragsart",
    fightStyle: "Kampfstil",
    eventName: "Veranstaltungsname",
    eventLocation: "Veranstaltungsort",
    date: "Datum",
    today: "Heute",
    yesterday: "Gestern",
    dealStatusMessageFailed: "Das Angebot wurde aktualisiert, aber die Chat-Nachricht konnte nicht gesendet werden.",
    system: {
      dealAccepted: "{{name}} hat das Angebot angenommen: {{summary}} {{dealId}}",
      dealRejected: "{{name}} hat das Angebot abgelehnt: {{summary}} {{dealId}}",
      dealWithdrawn: "{{name}} hat das Angebot zur\u00fcckgezogen: {{summary}} {{dealId}}",
      forSport: " f\u00fcr {{sport}}",
      previewAccepted: "Angebot angenommen: {{dealId}}",
      previewRejected: "Angebot abgelehnt: {{dealId}}",
      previewWithdrawn: "Angebot zur\u00fcckgezogen: {{dealId}}",
    },
    dealTypes: {
      FIGHT_SINGLE: "Einzelkampf",
      FIGHT_TOURNAMENT: "Kampfturnier",
      SPARRING: "Sparring",
    },
    dealStatus: {
      PROPOSED: "Vorgeschlagen",
      ACCEPTED: "Akzeptiert",
      CONFIRMED: "Best\u00e4tigt",
      WAITING_FOR_RESULT: "Wartet auf Ergebnis",
      RESULT_UPDATED: "Ergebnis aktualisiert",
      RESULT_CONFIRMED: "Ergebnis best\u00e4tigt",
      FINISHED: "Abgeschlossen",
      FIGHTER_RATED: "K\u00e4mpfer bewertet",
      MANAGER_RATED: "Manager bewertet",
      CANCELLED: "Zur\u00fcckgezogen",
      DISPUTE: "Streitfall",
      REJECTED: "Abgelehnt",
      EXPIRED: "Abgelaufen",
      CLOSED: "Geschlossen",
    },
    componentLabels: {
      BASE_AMOUNT: "Basisbetrag",
      TRAVEL_EXPENSE: "Reisekosten",
      PERFORMANCE_BONUS: "Leistungsbonus",
      BONUS: "Bonus",
      ON_WEIGHT_BONUS: "Gewichtsbonus",
    },
    typeLabel: "Typ:",
    priceLabel: "Preis:",
    sportLabel: "Sport:",
    locationLabel: "Ort:",
    eventDateLabel: "Veranstaltungsdatum:",
    acceptButton: "Annehmen",
    acceptBlockedByDocuments: "Erforderliche Dokumente hochladen, um anzunehmen",
    declineButton: "Ablehnen",
    editButton: "Bearbeiten",
    withdrawButton: "Zurückziehen",
    startConversation: "Beginnen Sie Ihre Unterhaltung mit {name}",
    messagesWillAppearHere: "Nachrichten werden hier angezeigt",
    selectContactOrGroup: "Wählen Sie einen Kontakt oder eine Gruppe aus",
    chooseSomeoneToChat: "Wählen Sie jemanden, um zu chatten",
    chooseGroupToChat: "Wählen Sie eine Gruppe zum Chatten",
    selectGroup: "Gruppe auswählen",
    groupInfo: "Gruppeninformationen",
    addMembers: "Mitglieder hinzufügen",
    leaveGroup: "Gruppe verlassen",
    noMembersFound: "Keine Mitglieder gefunden.",
    leaveGroupConfirm:
      "Sind Sie sicher, dass Sie die Gruppe verlassen möchten?",
    cancelButton: "Abbrechen",
    leaveButton: "Verlassen",
    leaving: "Verlässt...",
    makeADeal: "Ein Angebot machen",
    updating: "Aktualisieren...",
    loadingMessages: "Nachrichten werden geladen...",
    dealDetailsAria: "Angebotsdetails",
    membersUpdatedSuccessfully: "Mitglied erfolgreich aktualisiert",
    areYouSureLeaveGroup:
      "Sind Sie sicher, dass Sie die Gruppe verlassen möchten?",
    dropFiles: "Dateien hier ablegen",
    fileLimits: "Bilder, Videos und Dokumente werden unterstützt",
    fileLimitsWithoutVideo: "Bilder und Dokumente werden unterstützt",
  },
  hr: {
    selectInvite: "Odaberite pozivnicu",
    chooseInviteToView: "Odaberite pozivnicu za pregled",
    memberRemovedSuccess: "Član je uspješno uklonjen.",
    leftGroupSuccess: "Uspješno ste napustili grupu.",
    confirmRemoval: "Potvrdi uklanjanje",
    confirmRemovalMessage: "Jeste li sigurni da želite ukloniti ovog člana?",
    cancel: "Otkaži",
    confirm: "Potvrdi",
    addAccountDetails: "Dodaj podatke o računu",
    verificationPending: "Verifikacija na čekanju",
    chatsTab: "Razgovori",
    groupsTab: "Grupe",
    invitesTab: "Pozivnice",
    createNewGroup: "Stvori novu grupu",
    allRequests: "Svi zahtjevi",
    myInvites: "Moje pozivnice",
    noContactsFound: "Nema pronađenih kontakata",
    noGroupsFound: "Nema pronađenih grupa",
    createFirstGroup: "Stvorite svoju prvu grupu",
    noInvitesFound: "Nema pronađenih pozivnica",
    invitesWillAppearHere: "Pozivnice će se pojaviti ovdje",
    noChatsFound: "Nema pronađenih razgovora",
    startNewChat: "Započnite novi razgovor",
    noGroupFound: "Nema pronađenih grupa",
    createNewGroupHint: "Stvorite novu grupu",
    noChatMessagesYet: "Još nema poruka u razgovoru",
    noGroupMessagesYet: "Još nema poruka u grupi",
    decline: "Odbij",
    accept: "Prihvati",
    userWantsToContactYou: "Korisnik vas želi kontaktirati",
    acceptInvite: "Prihvati pozivnicu",
    dismissInvite: "Odbaci pozivnicu",
    messagePlaceholder: "Upišite poruku za...",
    filesToSend: "Datoteke za slanje",
    clearAll: "Obriši sve",
    uploading: "Učitavanje...",
    dealDetails: "Detalji ponude",
    paymentDetails: "Detalji pla\u0107anja",
    total: "Ukupno",
    withdrawn: "Povu\u010deno",
    contractType: "Vrsta ugovora",
    fightStyle: "Stil borbe",
    eventName: "Naziv doga\u0111aja",
    eventLocation: "Mjesto doga\u0111aja",
    date: "Datum",
    today: "Danas",
    yesterday: "Ju\u010der",
    dealStatusMessageFailed: "Ponuda je a\u017eurirana, ali poruka u chatu nije poslana.",
    system: {
      dealAccepted: "{{name}} je prihvatio/la ponudu: {{summary}} {{dealId}}",
      dealRejected: "{{name}} je odbio/la ponudu: {{summary}} {{dealId}}",
      dealWithdrawn: "{{name}} je povukao/la ponudu: {{summary}} {{dealId}}",
      forSport: " za {{sport}}",
      previewAccepted: "Ponuda prihva\u0107ena: {{dealId}}",
      previewRejected: "Ponuda odbijena: {{dealId}}",
      previewWithdrawn: "Ponuda povu\u010dena: {{dealId}}",
    },
    dealTypes: {
      FIGHT_SINGLE: "Pojedina\u010dna borba",
      FIGHT_TOURNAMENT: "Turnirska borba",
      SPARRING: "Sparing",
    },
    dealStatus: {
      PROPOSED: "Predlo\u017eeno",
      ACCEPTED: "Prihva\u0107eno",
      CONFIRMED: "Potvr\u0111eno",
      WAITING_FOR_RESULT: "\u010ceka se rezultat",
      RESULT_UPDATED: "Rezultat a\u017euriran",
      RESULT_CONFIRMED: "Rezultat potvr\u0111en",
      FINISHED: "Zavr\u0161eno",
      FIGHTER_RATED: "Borac ocijenjen",
      MANAGER_RATED: "Menad\u017eer ocijenjen",
      CANCELLED: "Povu\u010deno",
      DISPUTE: "Spor",
      REJECTED: "Odbijeno",
      EXPIRED: "Isteklo",
      CLOSED: "Zatvoreno",
    },
    componentLabels: {
      BASE_AMOUNT: "Osnovni iznos",
      TRAVEL_EXPENSE: "Putni tro\u0161kovi",
      PERFORMANCE_BONUS: "Bonus za izvedbu",
      BONUS: "Bonus",
      ON_WEIGHT_BONUS: "Bonus za ostvarenu te\u017einu",
    },
    typeLabel: "Vrsta:",
    priceLabel: "Cijena:",
    sportLabel: "Sport:",
    locationLabel: "Lokacija:",
    eventDateLabel: "Datum događaja:",
    acceptButton: "Prihvati",
    acceptBlockedByDocuments: "Učitajte potrebne dokumente da biste prihvatili",
    declineButton: "Odbij",
    editButton: "Uredi",
    withdrawButton: "Povuci",
    startConversation: "Započnite razgovor s {name}",
    messagesWillAppearHere: "Poruke će se pojaviti ovdje",
    selectContactOrGroup: "Odaberite kontakt ili grupu",
    chooseSomeoneToChat: "Odaberite nekoga za razgovor",
    chooseGroupToChat: "Odaberite grupu za razgovor",
    selectGroup: "Odaberite grupu",
    groupInfo: "Informacije o grupi",
    addMembers: "Dodaj članove",
    leaveGroup: "Napusti grupu",
    noMembersFound: "Nema pronađenih članova.",
    leaveGroupConfirm: "Jeste li sigurni da želite napustiti grupu?",
    cancelButton: "Odustani",
    leaveButton: "Napusti",
    leaving: "Napuštanje...",
    makeADeal: "Napravite ponudu",
    updating: "Ažuriranje...",
    loadingMessages: "Učitavanje poruka...",
    dealDetailsAria: "Detalji ponude",
    makeDeal: "Sklopi dogovor",
    membersUpdatedSuccessfully: "Član je uspješno ažuriran",
    areYouSureLeaveGroup: "Jeste li sigurni da želite napustiti grupu?",
    dropFiles: "Spustite datoteke ovdje",
    fileLimits: "Podržane su slike, videozapisi i dokumenti",
    fileLimitsWithoutVideo: "Podržane su slike i dokumenti",
  },
};

